import axios from '../api/axiosSetup3';
import { WireguardConf } from '../types/vpn';

const getWireguardConf = async (): Promise<WireguardConf[]> => {
    const res = await axios.get<WireguardConf[]>(`/wireguard_conf`, {
        headers: {
            'Accept-Profile': 'public' // schema
        }        
    });
    return res.data;
};

const postWireguardConf = async (data: WireguardConf): Promise<WireguardConf> => {
    const { id, row_hash, ...postData } = data;
    const res = await axios.post('/wireguard_conf', postData, {
        headers: {
            'Content-Profile': 'public', // schema
            'Prefer': 'return=representation', // <--- вернуть созданную строку            
        }        
    });
    if (res.status === 201 && Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0]; 
    }
    return {} as WireguardConf;
}

const putWireguardConf = async (data: WireguardConf): Promise<WireguardConf> => {
    const { row_hash, ...putData } = data;
    const res = await axios.put<WireguardConf>(`/wireguard_conf?id=eq.${data.id}`, putData, {
        headers: {
            'Content-Profile': 'public' // schema
        }        
    });
    return res.status === 204 ? data : {} as WireguardConf;
}

const deleteWireguardConf = async (id: number, ): Promise<void> => {
    await axios.delete<WireguardConf>(`/wireguard_conf?id=eq.${id}`, {
        headers: {
            'Content-Profile': 'public' // schema
        }        
    });
}


export const api = {
    getWireguardConf,
    putWireguardConf,
    postWireguardConf,
    deleteWireguardConf,
};